export const REVIEW_TEMPLATES = [
  "Всё верно, зачёт",
  "Нужно доработать",
  "Не хватает файлов",
] as const;

export const appendReviewTemplate = (comment: string, template: string): string => {
  const current = comment.trim();
  return current ? `${current} ${template}` : template;
};

export const getReviewActionAvailability = (comment: string, rating: number) => {
  const hasComment = Boolean(comment.trim());

  return {
    canApprove: hasComment && rating > 0,
    canRequestRevision: hasComment,
  };
};

export const formatResponseCreated = (value: string): string => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return new Intl.DateTimeFormat("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
    .format(date)
    .replace(",", " в");
};

export const attachmentCountLabel = (count: number): string => {
  if (!count) return "";

  const mod10 = count % 10;
  const mod100 = count % 100;
  let word = "вложений";

  if (mod10 === 1 && mod100 !== 11) word = "вложение";
  else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) word = "вложения";

  return `${count} ${word}`;
};
